import styled from "styled-components";
import { DescriptiveBlockWrapped } from "../../components/descriptiveBlock";
import { FurgoniIcons } from "./furgoniIcons";
import { NewsLetter } from "../../components/newsLetter";
import { MonthlyOffers } from "../home/monthlyOffers";
import { RoundedInfo } from "../../components/roundedInfo";
import { useCopertinaQuery } from "../../generated/graphql";

const ImgBanner = styled.img`
  width: 100%;
  height: auto;
`;

export function Furgoni() {
  const [copertina] = useCopertinaQuery({
    variables: { id: "tiyUfN3TL4t6BSE7QMuDY" },
  });
  return (
    <>
      <ImgBanner
        src={copertina.data?.copertina?.copertina?.url || ""}
      ></ImgBanner>
      <DescriptiveBlockWrapped id="M3QHAiKAKZcaQUdhrf2Xk" />
      <FurgoniIcons />

      <MonthlyOffers
        id="7nZE1vjk1hSdsGyWpb7c8G"
        size={1000}
        hideMoreButton
      />
      <RoundedInfo id="2XKs2NYcToqGFcpTB9U3Yz" center></RoundedInfo>
      <NewsLetter />
    </>
  );
}
